
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/looks",
      function () {
        return require("private-next-pages/looks/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/looks"])
      });
    }
  